import * as React from 'react';
import { ArticleHeading4, RadioButton } from '@cian/ui-kit';
import classNames from 'classnames';

import { useDeviceCondition } from '../../../../hooks';

import { IMoneySourceWidgetOption } from './types';
import * as styles from './MoneySource.css';

interface IProps {
  value: string;
  handleChange(v: string): void;
  options: IMoneySourceWidgetOption[];
}

export const MoneySource = ({ value, options, handleChange }: IProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={styles['wrapper']}>
      <div className={styles['label']}>
        <ArticleHeading4>Счёт размещения</ArticleHeading4>
      </div>

      <div className={classNames(styles['btns'], rootStyle)}>
        {options.map((option, i) => (
          <RadioButton
            key={i}
            value={option.value}
            name={option.value}
            label={option.label}
            disabled={option.disabled}
            checked={option.value === value}
            onChange={() => handleChange(option.value)}
          />
        ))}
      </div>
    </div>
  );
};
